import type { LucideIcon } from 'lucide-react';
import { BookOpenCheck, MessageSquare, ServerCog, UserRound } from 'lucide-react';

import styles from './FourStageRoutingDiagram.module.css';

interface Stage {
  emphasis?: boolean;
  icon: LucideIcon;
  subtitle: string;
  title: string;
}

const stages: Stage[] = [
  {
    icon: UserRound,
    subtitle: 'Asked from inside the Kudu course.',
    title: 'Student or faculty query',
  },
  {
    emphasis: true,
    icon: ServerCog,
    subtitle: 'Anonymize, add course context, apply pedagogy framing.',
    title: 'Kudu',
  },
  {
    icon: BookOpenCheck,
    subtitle: 'Swappable. No training on data.',
    title: 'Frontier model',
  },
  {
    icon: MessageSquare,
    subtitle: 'Returned through Kudu, scoped to course content.',
    title: 'Answer in context',
  },
];

export function FourStageRoutingDiagram() {
  return (
    <div
      aria-label="How KAI routes a query through Kudu, a swappable model, and back into course context"
      className={styles.wrapper}
      role="img"
    >
      <div className={styles.stages}>
        {stages.map(({ emphasis, icon: Icon, subtitle, title }) => (
          <article
            className={styles.stage}
            data-emphasis={emphasis ? 'true' : undefined}
            key={title}
          >
            <span aria-hidden="true" className={styles.icon}>
              <Icon size={20} />
            </span>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.subtitle}>{subtitle}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
